import { useQuery, UseQueryResult } from '@tanstack/react-query';
import schoolGroupsAPI from 'api/schoolGroupsAPI';
import schoolsAPI from 'api/schoolsAPI';
import { ActiveDistrictSchool } from 'features/TalentMarketplace/TalentFiltersSidebar.types';

export const useQueryGetActiveSchoolsByDistrict = (
  districtId: number,
  options?: { [option: string]: boolean | number }
): UseQueryResult<ActiveDistrictSchool[], unknown> => {
  return useQuery({
    ...options,
    queryKey: ['groupedActiveSchoolsByDistrict', districtId],
    queryFn: () => schoolsAPI.fetchActiveSchools(districtId).then((res) => res),
    refetchOnWindowFocus: false,
  });
};

export interface SchoolGroup {
  district_id: number;
  id: number;
  name: string;
  schools: number[];
}

export const useQueryGetSchoolGroupsByDistrict = (
  districtId: number,
  options?: { [option: string]: boolean | number }
): UseQueryResult<SchoolGroup[], unknown> => {
  return useQuery({
    ...options,
    queryKey: ['schoolGroupsByDistrict', districtId],
    queryFn: () => schoolGroupsAPI.getSchoolGroups().then((res) => res),
    refetchOnWindowFocus: false,
  });
};
